module.exports = __webpack_public_path__ + "static/media/52.998e9846.png";